// extracted by mini-css-extract-plugin
module.exports = {"textColorDark":"#354051"};